export const WALLET_WECHAT_STORE_PF = ["__mds_wx_qb", "__mds_wx_HK"]
export const WECHAT_STORE_PF_DEFAULT_ENTRANCE = "__mds_wx_other"
export const MQQ_STORE_PF_DEFAULT_ENTRANCE = "__mds_sq_other"
export const WECHAT_STORE_NON_GUIDE_PF = ["__mds_wxservice_menu", "__mds_wx_qb", "__mds_wx_HK"]
export const MOBILE_BROWSER_PAY_PF = ["2199", "__mds_default"]
export const WALLET_DIRECT_CGI_PF_SOURCE = "mds_wechat_qb"
export const DEFAULT_PF_SOURCE = "mds_storeopen_qb"
export const SQ_PF_SOURCE = "mds_qq_qb"
export const MIDAS_APP_PF_SOURCE = "mds_midasapp_qb"
export const NANJI_PF_SOURCE = "midas_ROG" //30145
export const WEISHI_SOURCE = "mds_ws_android" //30149
export const KUAISHOU_SOURCE = "mds_kuaishou_pay" //30162
export const EGAME_SOURCE = "mds_dianjing_pay" //30163
export const BIGR_SOURCE = "pay_R" //30131
export const XINYUE_STORE_PF = "__mds_xinyueapp_game"
export const PAY_WECHAT_SCAN_PF = "__mds_pay_scan_wechat_qrcode_for_wechat_account"
export const GAME_STORE_PF = "gmshop"
export const WEISHI_SOURCE_PF = "__mds_weishi_game"
export const BIGR_PF = "__mds_bigR"
export const EGAME_SOURCE_PF = "__mds_egame"
export const KUAISHOU_SOURCE_PF = "__mds_kuaishou"
export const WXGAME_SOURCE_PF = "__mds_wxgame"
export const WX_SHARE_PF = "__mds_wx_share"
export const WZRY_SHOP_SOURCE = "mds_wzrygzh"
export const MYAPPJP_SHOP_SOURCE = "mds_myappjp"
export const NO_COUPONS = "noCoupon"
export const STORE_PF_PREFIX = ["__mds_wx", "__mds_sq", "__mds_nanji"]
export const DISABLE_NOT_WECHAT_CHANNELS = "qdqb,qbqd,bank,qqcard,mcard,hfpay,yb,wsjpay,qqwallet"
export const QQ_SESSION_TYPE = ["skey", "kp_actoken", "kp_accesstoken"]
export const QQ_CONNECT_SESSION_TYPE = ["kp_actoken", "kp_accesstoken"]
export const WX_SESSION_TYPE = ["wc_actoken"]
export const MQQ_JSAPI_URL = "//open.mobile.qq.com/sdk/qqapi.js?_bid=152"
export const WEISHI_JSAPI_URL = "//qzonestyle.gtimg.cn/qzone/hybrid/app/weishi/lib/wsapi.js"
export const QQ_BROWSER_JSAPI_URL = "//jsapi.qq.com/get?api=login.getAccountInfo"

// pfSource
export const ALLOW_SHOW_HOME_ICON_PFSOURCE = [
  "mds_wechat_qb",
  "mds_wechat_gmshop",
  "mds_qq_qb",
  "mds_qq_gmshop",
  "mds_xcx_android",
  "mds_xcx_ios",
  "mds_storeopen_qb"
]
// 指定分店pfSource
export const ALLOW_SHOW_HOME_ICON_SHOP_PFSOURCE = ["mds_Qgametxcz", "mds_shipin_pay"]
export const DISABLE_RATE_PFSOURCE = ["mds_wzrygzh"]
export const DISABLE_BACKPACK_PFSOURCE = ["mds_wzyd"]
export const DISABLE_ACCOUNT_SWITCH_INMINI = ["mds_zhangdaxian"]

export const WX_APPID = "wx951bdcac522929b6"
export const QQ_APPID = "101502376"
export const IOS_AID = "mios.pingtai.wechat.wxye_ktvip"
export const ANDROID_AID = "mvip.pingtai.wechat.wxye_ktvip"
export const RESULT_ADS = "//pay.qq.com/h5/ads/25.json"
export const PRODUCT_PRICE_ADS = "//pay.qq.com/h5/ads/26.json"
export const INDEX_BANNER_ADS = "//pay.qq.com/h5/ads/27.json"
export const GAME_BANNER_ADS = "//pay.qq.com/h5/ads/39.json"
export const GAME_RESERVATION_BANNER_ADS = "//pay.qq.com/h5/ads/54.json"
export const GAME_RESERVATION_TIME_ADS = "//pay.qq.com/h5/ads/55.json"
export const LIST_ADS = "//pay.qq.com/h5/ads/28.json"
export const RESULT_LOTEERY_ADS = "//pay.qq.com/h5/ads/30.json"
export const MALL_ADS = "//pay.qq.com/h5/ads/68.json"
export const DETAIL_ADS = "//pay.qq.com/h5/ads/86.json"
// export const WZRY_ACTIVITY_ADS = "//pay.qq.com/h5/ads/42.json"
export const WZRY_RANK_DETAIL_URL_PATH = "/h5/store/get_wzry_zone_data.php?action=getDetailRankListById"
export const WZRY_NEWS_SEARCH_URL_PATH = "/h5/store/get_wzry_zone_data.php"
export const WZRY_TAG_CONFIG_URL_PATH = "/h5/active/static_data/wzry/wzry_tag_list.json"
export const IP_ZONE_CONFIG_URL_PATH = "/h5/store_config/ipzone/ipzone.json"
export const IP_ZONE_ALL_SHELF_CONFIG_URL_PATH = "/h5/store_config/shelf/shelf_ipzone.json"
export const GAME_SHELF_CONFIG_URL_PATH = "/h5/store_config/shelf/shelf.json"
export const WZRY_GAME_SHELF_CONFIG_URL_PATH = "/h5/store_config/shelf/shelf_wzry.json"
export const WZRY_GAME_DETAIL_RELATE = "/h5/store_config/wzry_guru_remark/wzry-guru-remark.json"
export const POP_DIALOG_CONFIG_URL_PATH = "/h5/store_config/wechat_store_pop_dialog/wechat_store_pop_dialog.json"
export const PROP_GROUP_CONFIG_PATH = "/h5/store_config/groupbuy/groupbuy/"
export const INDEX_GUESS_YOU_LIKE = "/h5/store_config/mini_recommend_play/mini_recommend_play.json"
// CDKey兑换配置
export const CDKEY_EXCHANGE_CONFIG_PATH = "/h5/store_config/cdkey_exchange_config/cdkey_exchange_config.json"

// 好店+集市店铺配置
export const INDEX_MALL_URL_PATH = "/h5/store_config/mall/mall.json"
export const INDEX_MALL_URL_OPERATE = "/h5/store_config/mall_operator/mall_operator.json"

export const MUNTH_CARD_CONFIG_URL_PATH = "/h5/store_config/store_month_card/store_month_card.json"
export const PRE_ORDER_CONFIG_URL_PATH = "//pay.qq.com/h5/store_config/pre_order_config/pre_order_config/$$$.json"
export const RESERVATION_CONFIG_URL_PATH = "//pay.qq.com/h5/store_config/store_reservation/store_reservation.json"
export const RECOMMEND_PLAY_CONFIG_URL_PATH = "//pay.qq.com/h5/store_config/store_recommend_play/store_recommend_play.json"
export const GAME_ZONE_LIST_BANNER_ADS = "//pay.qq.com/h5/ads/63.json"
export const GAMESHOP_BANNER_ADS = "//pay.qq.com/h5/ads/64.json"

// 游戏币+包月 绑定购买，配置文件地址
export const GAMECOIN_BIND_CONFIG_URL_PATH = "/h5/store_config/qb_plus/game_coin_plus.json"

// 个人中心权益配置
export const RIGHTS_INTERESTS_URL_PATH = "/h5/store_config/rights_interests/rights_interests/rights_interests.json"

// 商店和活动页的pf映射配置
export const STORE_PF_MAP_SOURCE = "/h5/store_config/pf_map_source/pf_map_source/pfToSource.json"
// 预售道具amsid-preSaleEndTime
export const PROPS_PRE_SALE_LIST = "/h5/store_config/props_PreSale/props_PreSale/props_PreSale.json"

// 小店跳页匠地址
export const LIVE_PAGEDOO_URL_MAP = "/h5/store_config/live_pagedoo_url_map/live_pagedoo_url_map.json"

// 历史搜索最大记录个数
export const MAX_SEARCH_HISTORY_CAPACITY = 10
// 专区页面-历史搜索最大记录个数
export const SERVICEZONE_MAX_SEARCH_HISTORY_CAPACITY = 10

export const WECHAT_DEFAULT_DISCOUNT = 97

export const NANJI_PF = "__mds_nanji"

export const STORE_IP_ZONE_LINK_REGULAR = /pay\.qq\.com\/[^#]*#\/tabList/

export const DISABLE_FULI_ZONE_PF = ["__mds_wx_HK"]

export const SHOP_OFFERID = "1450000186"

export const QB_GROUPID = 76

export const QB_BUSID = 98

// 多少人以下评分过滤
export const RATING_UV_SIZE = 20

export const RATING_SIZE = 50

export const RATING_TOP_SIZE = 20

// 订单中心页面 - 历史搜索最大记录个数
export const ORDER_CENTER_MAX_SEARCH_HISTORY_CAPACITY = 10

// 需要调用wxConfig的路由
export const WXCONFIGROUTEARR = [
  "/",
  "/tabList",
  "/order/462/biz/500",
  "/order/20/biz/338",
  "/order/20/biz/337",
  "/order/20/biz/224",
  "/order/20/biz/30",
  "/order/20/biz/29"
]

export const INDEPENDENT_ROUTE = ["/bind", "/gameReceive", "/gameShop"]
// 王者礼品卡amsid 史诗、传说
export const GIFTCARD_AMSIDS = ["IEGAMS-461739-476065_2048205", "IEGAMS-461739-476065_2048206"]

// 点券购买、汇率 需要做特殊处理的offerid
export const SPECIAL_OFFERID = ["1450011404", "1450011405", "1450011406"]
